import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { Filter } from '@jaimo-solutions-gmbh/platform-services-module';
import { Swiper } from 'swiper';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss'],
})
export class FilterBarComponent implements OnInit {
  @ViewChild('filterSwiper') swiperRef: ElementRef<SwiperContainer>;

  @Output() onFilterChange = new EventEmitter<Filter>();

  @Input() filters: Filter[];
  @Input() active: any;
  @Input() navigation: boolean;
  @Input() isLoading: boolean;

  swiper: Swiper;
  slideNextIcon = faChevronRight;
  slidePrevIcon = faChevronLeft;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.initializeSlider();
  }

  initializeSlider() {
    const swiperEl = this.swiperRef.nativeElement;
    Object.assign(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
    });

    swiperEl.initialize();

    this.swiper = this.swiperRef.nativeElement.swiper;
  }

  filterChanged(filter) {
    if (filter !== this.active) this.onFilterChange.emit(filter);
  }
}
